// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateGoodsInstallationVat = (goodsInstallationVatOptions, optionSelected) => {

    const defaultOption = {
        key: '',
        value: ''
    };

    const goodsInstallationVat = optionSelected ?
        goodsInstallationVatOptions.find(option => option.key === optionSelected) :
        defaultOption;

    return {
        goodsInstallationVat,
        type: actions.UPDATE_CLAIM_NORMAL_GOODS_INSTALLATION_VAT
    };

};



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/update-goods-installation-vat.js